import React from 'react';
import PropTypes from 'prop-types';

import { uiConfig } from '../../../../../../../../../conf/lists';

// Components
import Table from '../../../../../../../../../../components/Table';
import { Spinner } from '../../../../../../../../../../components/Spinner';
import { ConstraintTypeModal } from './ConstraintTypeModal';

// Context
import { CriteriaStoreContext } from '../../../../../../../../state/criteria/context';

// Hooks
import { useGetLists } from '../../../../../../../../../../common/hooks/useGetLists';

// Utils
import { translateUIConfigForTable } from '../../../../../../../../../../common/utility';

export const ListsTableModal = (props) => {
    const { sessionToken } = React.useContext(CriteriaStoreContext);
    const { data, isLoading } = useGetLists({ sessionToken });
    const { columns, initialState } = translateUIConfigForTable(uiConfig);

    return (
        <ConstraintTypeModal header={'Lists'} id={'constraint-type-lists-modal'} {...props}>
            {!isLoading ? (
                <Table
                    withHeader={true}
                    columns={columns}
                    data={data}
                    withActions={false}
                    rowClickAction={(rowData) => props?.onSelect?.(rowData)}
                    id={'list-manager'}
                    label={'Lists'}
                    showControlDeck={true}
                    paginated={true}
                    loading={isLoading}
                    initialState={initialState}
                />
            ) : (
                <Spinner size={'2.3rem'} color={'#7f7f7f'} style={{ margin: '0 auto' }} />
            )}
        </ConstraintTypeModal>
    );
};

ListsTableModal.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func
};

export default ListsTableModal;
